import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import Swal from 'sweetalert2';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceInRequiredValidator } from '../../../shared/constants';

@Component({
	selector: 'app-category-create',
	templateUrl: './category-create.component.html',
	styleUrl: './category-create.component.scss'
})
export class CategoryCreateComponent implements OnInit, AfterViewInit {
	breadcrumbList = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/category-list",
			name: "Categories"
		}
	];
	uId: any = null;
	pagetitle = "Create Category";
	moduleForm!: FormGroup;
	showLoader: boolean = false;
	pageLoading: boolean = false;
	details: any = null;
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted = false;
	scaleList: any[] = [];
	questionList: any = [];

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) { }
	ngAfterViewInit(): void { }

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["uId"] == undefined ? null : routeParams["uId"];
			this.moduleForm = this.formBuilder.group({
				name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
				scales_id: [null, [Validators.required, noWhitespaceInRequiredValidator]],
				questions: this.formBuilder.array([])
			});
			this.getScaleList();
			this.getQuestionList();
			if (this.uId) {
				this.breadcrumbList.push({ path: "/app/edit-category/" + this.uId, name: "Edit" });
				this.pagetitle = "Edit Category";
				this.getDetails();
			} else {
				this.breadcrumbList.push({ path: "/app/create-category", name: "Create" });
			}
		});
	}

	getScaleList() {
		this.apiService.getAllScaleList().subscribe({
			next: (data: any) => {
				this.scaleList = data.data.map((s) => {
					s["id"] = parseInt(s["id"]);
					return s;
				});
			}, error: (error) => {
				this.scaleList = [];
				this.toastr.error("Unable to fetch scale list.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getQuestionList() {
		this.apiService.getAllQuestions().subscribe({
			next: (data: any) => {
				this.questionList = data.data;
			}, error: (error) => {
				this.questionList = [];
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	showError2(index: number, field: string) {
		let f: any = this.get_rows.controls[index].get(field);
		if (f.invalid && (this.formSubmitted || f.touched || f.dirty)) {
			return true;
		}
		return false;
	}

	formChanged() {
		this.moduleForm.markAsDirty();
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getCategoryDetails(this.uId).subscribe({
			next: (data: any) => {
				this.pageLoading = false;
				this.details = data;
				this.f.name.setValue(this.details.name);
				this.f.scales_id.setValue(this.details.scales_id);
				let questions: any = this.details.questions;
				let len = questions.length;
				for (let i = 0; i < len; i++) {
					this.addRow();
					this.get_rows.controls[i].get("que")?.setValue(questions[i].que);
					this.get_rows.controls[i].get("condition")?.setValue(questions[i].condition);
					this.get_rows.controls[i].get("value")?.setValue(questions[i].value);
				}
			}, error: (error) => {
				this.pageLoading = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch details.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	get f() { return this.moduleForm.controls; }

	get get_rows() {
		return this.moduleForm.controls['questions'] as FormArray;
	}

	addRow() {
		const form = this.formBuilder.group({
			que: [null, [Validators.required]],
			condition: [null, [Validators.required]],
			value: [null, [Validators.required]]
		});
		this.get_rows.push(form);
	}

	deleteRow(index: number) {
		this.get_rows.at(index).markAsUntouched();
		this.get_rows.at(index).updateValueAndValidity();
		this.get_rows.removeAt(index);
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {

				}

			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let questions: any = [];
		for (let i = 0; i < this.get_rows.controls.length; i++) {
			questions.push({
				que: this.get_rows.controls[i].get("que")?.value,
				condition: this.get_rows.controls[i].get("condition")?.value,
				value: this.get_rows.controls[i].get("value")?.value,
			});
		}
		let payload: any = {
			name: this.f.name.value,
			scales_id: this.f.scales_id.value,
			questions: questions
		};
		let action = "create";
		if (this.uId) {
			payload["id"] = this.uId;
			action = "edit";
		}
		this.showLoader = true;
		this.apiService.createUpdateCategory(payload, action).subscribe({
			next: data => {
				this.showLoader = false;
				this.toastr.success("Saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.gotoList();
			}, error: (error: any) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				if (error.status == 409) {
					Swal.fire({
						title: 'Already Exists',
						html: 'Category already exists. Do you want to restore it?',
						icon: 'question',
						showCancelButton: true,
						showConfirmButton: true,
						confirmButtonText: 'Yes, Restore!',
						cancelButtonText: 'Cancel',
						confirmButtonColor: '#3e4fb1'
					}).then((result) => {
						if (result.value) {
							this.apiService.restoreCategory(error.error.encryptid).subscribe({
								next: (data: any) => {
									this.toastr.success("Category restored successfully", 'Success', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
									this.gotoList();
								}, error: (error) => {
									this.toastr.error("Something went wrong", 'Error', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
								}
							});
						} else if (result.dismiss === Swal.DismissReason.cancel) { }
					})
				} else {

					if (error.status == 400) {
						this.alreadyExistsError();
					} else {
						let errorMsg: any = "Something went wrong.";
						this.toastr.error(errorMsg, 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				}
			}
		});
	}

	alreadyExistsError() {
		let key = "name";
		let val: any = "Already exists";
		this.moduleForm.controls[key].setErrors({ incorrect: true });
		this.customError[key] = val;
		let selector = "#" + key;
		try {
			$('html, body').animate({
				scrollTop: $(selector).offset().top - 60 + 'px'
			}, 'fast');
		} catch (error) { }
		$(selector).focus();
		return;
	}

	gotoList() {
		this.router.navigate(['/app/category-list']);
	}
}
